import React from 'react'

import Page from '../Page'
import PullQuote from '../../PullQuote'

const ShortTextPanel = ({
  id,
  panelColor,
  panelTexture,
  panelLabel,
  panelLabelColor,
  ...blockProps
}) => {
  return (
    <Page.Panel color={panelColor} texture={panelTexture} key={`panel${id}`}>
      {panelLabel && (
        <Page.Panel.Label color={panelLabelColor}>
          {panelLabel}
        </Page.Panel.Label>
      )}
      <PullQuote {...blockProps} />
    </Page.Panel>
  )
}

export default ShortTextPanel
